import { PageTitle, Routes } from '@/constants';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: Routes.DASHBOARD,
    component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/dashboard/DashBoard.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      requireJobId: true,
      session: true,
      title: PageTitle.DASHBOARD
    }
  },
  {
    path: '/signin',
    name: Routes.SIGNIN,
    component: () => import(/* webpackChunkName: "signIn" */ '@/views/signin/SignIn.vue'),
    meta: {
      requiresRedirect: true,
      title: PageTitle.SIGNIN
    }
  },
  {
    path: '/media',
    name: Routes.PHOTOS,
    component: () => import(/* webpackChunkName: "MyPhotos" */ '@/views/myphotos/MyPhotos.vue'),
    meta: {
      requiresAuth: true,
      requireJobId: true,
      session: true,
      title: PageTitle.PHOTOS
    }
  },
  {
    path: '/documents',
    name: Routes.DOCUMENTS,
    component: () => import(/* webpackChunkName: "Document" */ '@/views/mydocuments/MyDocuments.vue'),
    meta: {
      requiresAuth: true,
      requireJobId: true,
      session: true,
      title: PageTitle.DOCUMENTS
    }
  },
  {
    path: '/verify',
    name: Routes.VERIFY,
    component: () => import(/* webpackChunkName: "verify" */ '@/views/verification/Verify.vue'),
    meta: {
      requiresRedirect: true,
      title: PageTitle.VERIFY
    }
  },
  {
    path: '/account',
    name: Routes.MY_ACCOUNT,
    component: () => import(/* webpackChunkName: "MyAccount" */ '@/views/myaccount/MyAccount.vue'),
    meta: {
      requiresAuth: true,
      mobileView: true,
      session: true,
      title: PageTitle.MY_ACCOUNT
    }
  },
  {
    path: '/resetPassword',
    name: Routes.RESET_PASSWORD,
    component: () => import(/* webpackChunkName: "ResetPassword" */ '@/views/resetpassword/ResetPassword.vue'),
    meta: {
      requiresRedirect: true,
      title: PageTitle.RESET_PASSWORD
    }
  },
  {
    path: '/selecthome',
    name: Routes.SELECT_HOME,
    component: () => import(/* webpackChunkName: "SelectHome" */ '@/views/selecthome/SelectHome.vue'),
    meta: {
      requiresAuth: true,
      session: true,
      title: PageTitle.SELECT_HOME
    }
  },
  {
    path: '/appointments',
    name: Routes.APPOINTMENTS,
    component: () => {
      if (process.env.VUE_APP_SHOW_APPOINTMENT === 'true') {
        return import(/* webpackChunkName: "Appointments" */ '@/views/appointments/Appointments.vue');
      }
      return import(/* webpackChunkName: "SiteError" */ '@/components/site-error/SiteError.vue');
    },
    meta: {
      requiresAuth: true,
      session: true,
      requireJobId: true,
      title: PageTitle.APPOINTMENTS
    }
  },
  {
    path: '/schedule/:appointmentTypeId',
    name: Routes.SCHEDULE_APPOINTMENT,
    component: () => {
      if (process.env.VUE_APP_SHOW_APPOINTMENT === 'true') {
        return import(/* webpackChunkName: "ScheduleAppointments" */ '@/views/schedule-appointments/ScheduleAppointment.vue');
      }
      return import(/* webpackChunkName: "SiteError" */ '@/components/site-error/SiteError.vue');
    },
    meta: {
      requiresAuth: true,
      session: true,
      requireJobId: true,
      title: PageTitle.SCHEDULE_APPOINTMENT
    }
  },
  {
    path: '/modify/:appointmentTypeId',
    name: Routes.MODIFY_APPOINTMENT,
    component: () => {
      if (process.env.VUE_APP_SHOW_APPOINTMENT === 'true') {
        return import(/* webpackChunkName: "ModifyAppointments" */ '@/views/schedule-appointments/ScheduleAppointment.vue');
      }
      return import(/* webpackChunkName: "SiteError" */ '@/components/site-error/SiteError.vue');
    },
    meta: {
      requiresAuth: true,
      session: true,
      requireJobId: true,
      title: PageTitle.MODIFY_APPOINTMENT
    }
  },
  {
    path: '/messages',
    name: Routes.MESSAGES,
    component: () => {
      if (process.env.VUE_APP_SHOW_MESSAGE === 'true') {
        return import(/* webpackChunkName: "Appointments" */ '@/views/messages/MyMessages.vue');
      }
      return import(/* webpackChunkName: "SiteError" */ '@/components/site-error/SiteError.vue');
    },
    meta: {
      requiresAuth: true,
      session: true,
      requireJobId: true,
      title: PageTitle.MESSAGES
    }
  },
  {
    path: '/messages/:teamMemberId',
    name: Routes.TEAM_MEMBER_MESSAGE,
    component: () => {
      if (process.env.VUE_APP_SHOW_MESSAGE === 'true') {
        return import(/* webpackChunkName: "Appointments" */ '@/views/messages/MyMessages.vue');
      }
      return import(/* webpackChunkName: "SiteError" */ '@/components/site-error/SiteError.vue');
    },
    meta: {
      requiresAuth: true,
      session: true,
      requireJobId: true,
      title: PageTitle.MESSAGES
    }
  },
  {
    path: '*',
    name: Routes.ERROR,
    component: () => import(/* webpackChunkName: "SiteError" */ '@/components/site-error/SiteError.vue')
  }
];

export default { routes };
